import {
    convertUniversalDateTimeToPersianDateTime,
    convertUniversalDateToPersianDate, convertUniversalDateToPersianDateFullInfo,
    RaikoBaseCardContainer,
    RaikoBaseContainer,
    RaikoDatePicker,
    RaikoGridOneColumn,
    RaikoGridThreeColumn,
    RaikoGridTwoColumn,
    RaikoMoneyInputOutlined,
    RaikoSectionContainer,
    RaikoSimpleInputOutlined,
    RaikoSimpleMultiLineInputOutlined,
    RaikoToggleOutlined, showErrorMessage, showServerErrorMessage, showSuccessMessage,
    showWarningMessage
} from "@moeindal/base-raiko-panel-components";
import {css} from "@emotion/css";
import React, {useEffect, useState} from "react";
import {OtherPaymentsService} from "../otherPayments/OtherPaymentsService";
import {useAuthState} from "../../context/AuthContext";
import {LoadingHelper} from "../../util/LoadingHelper";
import {useLoadingDispatcher} from "../../context/LoadingContext";
import {useParams} from "react-router-dom";
import {detectServerErrorMessage} from "../../util/detectServerErrorMessage";
import CreatorInfo from "../../component/creatorInfo/CreatorInfo";

export default function OtherPaymentBasicInfo() {
    const [title, setTitle] = useState("");
    const [startDate, setStartDate] = useState("");
    const [endDate, setEndDate] = useState("");
    const [unit, setUnit] = useState("");
    const [paid, setPaid] = useState("");
    const [expirationDate, setExpirationDate] = useState(false);
    const [description, setDescription] = useState("");
    const [state, setState] = useState(false);
    const [createdBy, setCreatedBy] = useState("");
    const [createdAt, setCreatedAt] = useState("");

    const loading = new LoadingHelper(useLoadingDispatcher());


    const service = new OtherPaymentsService()

    const {fundID} = useAuthState()
    const {id: paymentId} = useParams()

    useEffect(() => {
        getOtherPaymentFromServer()
    }, [fundID, paymentId])

    function checkAllInputs() {
        let message = ""
        let state = false

        if (title.length === 0)
            message = "لطفا عنوان را به درستی وارد نمایید."
        else if (startDate.length === 0)
            message = "لطفا تاریخ شروع را به درستی وارد نمایید."
        else if (endDate.length === 0)
            message = "لطفا تاریخ پایان را به درستی وارد نمایید."
        else if (unit.length === 0)
            message = "لطفا واحد را به درستی وارد نمایید."
        else if (paid.length === 0)
            message = "لطفا مقدار را به درستی وارد نمایید."
        else if (description.length === 0)
            message = "لطفا توضیحات را به درستی وارد نمایید."
        else
            state = true
        if (message && message.length > 0)
            showWarningMessage(message)
        return state

    }

    function getOtherPaymentFromServer() {
        loading.show()
        service.getOtherPaymentBasicInfo(fundID, paymentId).then(
            response => {
                setTitle(response.title)
                setStartDate(convertUniversalDateToPersianDate(response.startDate))
                setEndDate(convertUniversalDateToPersianDate(response.endDate))
                setUnit(response.unit)
                setPaid(response.amountPerUnit)
                setExpirationDate(response.hasExpiredTime)
                setDescription(response.description)
                setState(response.enabled)
                setCreatedBy(response.createdBy)
                setCreatedAt(convertUniversalDateTimeToPersianDateTime(response.createdAt))
            }
        ).catch(reason => {
            showErrorMessage(detectServerErrorMessage(reason))
        }).finally(_ => {
            loading.hide()
        })
    }

    function handleUpdateOtherPayment() {
        if (checkAllInputs()) {
            loading.show()
            service.updateOtherPayment(
                fundID,
                paymentId,
                title,
                startDate,
                endDate,
                unit,
                paid,
                expirationDate,
                description,
                state
            ).then(
                response => {
                    showSuccessMessage("بروزرسانی با موفقیت انجام شد.")
                }
            ).catch(reason => {
                showErrorMessage(detectServerErrorMessage(reason))
            }).finally(_ => {
                loading.hide()
            })
        }
    }


    return (
        <RaikoGridOneColumn>
            <RaikoBaseCardContainer>
                <RaikoSectionContainer
                    title={"اطلاعات پایه"}
                    hasActionButton
                    actionButtonOnclick={handleUpdateOtherPayment}
                >
                    <RaikoGridOneColumn>
                        <RaikoGridThreeColumn>
                            <RaikoSimpleInputOutlined
                                labelText={"عنوان"}
                                value={title}
                                setValue={setTitle}
                            />
                            <RaikoDatePicker
                                label={"تاریخ شروع"}
                                date={startDate}
                                setDate={setStartDate}
                            />
                            <RaikoDatePicker
                                label={"تاریخ پایان"}
                                date={endDate}
                                setDate={setEndDate}
                            />
                        </RaikoGridThreeColumn>
                        <RaikoGridTwoColumn>
                            <RaikoToggleOutlined
                                checked={expirationDate}
                                setChecked={setExpirationDate}
                                labelText={"با تاریخ انقضا / بدون تاریخ انقضا"}
                            />
                            <RaikoToggleOutlined
                                checked={state}
                                setChecked={setState}
                                labelText={"فعال / غیر فعال"}
                            />
                            <RaikoSimpleInputOutlined
                                labelText={"واحد"}
                                placeHolder={"کیلوگرم،کارتن،عدد و ..."}
                                value={unit}
                                setValue={setUnit}
                            />
                            <RaikoMoneyInputOutlined
                                labelText={"مبلغ (ریال)"}
                                value={paid}
                                setValue={setPaid}
                            />
                        </RaikoGridTwoColumn>
                        <RaikoSimpleMultiLineInputOutlined
                            labelText={"توضیحات"}
                            value={description}
                            setValue={setDescription}
                        />

                    </RaikoGridOneColumn>

                </RaikoSectionContainer>
            </RaikoBaseCardContainer>
            <CreatorInfo createdBy={createdBy} createdAt={createdAt}/>
        </RaikoGridOneColumn>
    )
}